export default __webpack_public_path__ + "static/Mask-Group-3@2x-40b2a81e239b9e3bf669c7c4792f7e46.png";